package one.healthium.base.utils

import kotlinx.datetime.DayOfWeek
import kotlinx.datetime.Month

// Jan 1, 2024 was a Monday (DayOfWeek.MONDAY, ordinal=0) — used as the anchor date.
// Date.UTC + timeZone:'UTC' avoids local timezone shifts for users west of UTC.

@Suppress("unused")
internal actual fun Month.getLocalizedName(abbreviated: Boolean): String {
    val monthIndex = ordinal
    val style = if (abbreviated) "short" else "long"
    return js("new Intl.DateTimeFormat(navigator.language, { month: style, timeZone: 'UTC' }).format(new Date(Date.UTC(2024, monthIndex, 1)))")
}

@Suppress("unused")
internal actual fun DayOfWeek.getLocalizedName(abbreviated: Boolean, narrow: Boolean): String {
    val dayOffset = ordinal
    val style = when {
        narrow -> "narrow"
        abbreviated -> "short"
        else -> "long"
    }
    return js("new Intl.DateTimeFormat(navigator.language, { weekday: style, timeZone: 'UTC' }).format(new Date(Date.UTC(2024, 0, 1 + dayOffset)))")
}
